/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { call, put } from 'redux-saga/effects';
import { signOut } from '../api';
import { isWeb } from '../storage';
import SecureLS from 'secure-ls';
import { userLogout } from '../reducer/userSlice';
import {
  resetContactInfoSlice,
  resetManageAlertsSlice,
  resetRequest,
  resetOffersSlice,
  resetValidatePasscodeSlice,
} from '@rb-serve-app/core';

export function* signOutSaga(action: any) {
  const { apiName, data, accountId } = action.payload;
  try {
    yield call(signOut, apiName, data, accountId);
  } catch (error) {
    console.log('SignOut Error==>', error);
  } finally {
    if (isWeb) {
      const ls = new SecureLS({ encodingType: 'aes' });
      yield put(resetRequest(null));
      yield put(resetOffersSlice());
      yield put(resetManageAlertsSlice());
      yield put(resetContactInfoSlice());
      yield put(resetValidatePasscodeSlice());
      localStorage.removeItem('hasDismissedOffer');
      ls.remove('user');
      ls.remove('tokens');
      yield put(userLogout());
    }
  }
}
